/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaWasher: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="washer" viewBox="0 0 15 15">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 3.125C1.25 1.74607 2.37107 0.625 3.75 0.625H11.25C12.6289 0.625 13.75 1.74607 13.75 3.125V13.125C13.75 13.4565 13.6183 13.7745 13.3839 14.0089C13.1495 14.2433 12.8315 14.375 12.5 14.375H2.5C2.16848 14.375 1.85054 14.2433 1.61612 14.0089C1.3817 13.7745 1.25 13.4565 1.25 13.125V3.125ZM3.75 1.875C3.06143 1.875 2.5 2.43643 2.5 3.125V13.125H12.5V3.125C12.5 2.43643 11.9386 1.875 11.25 1.875H3.75Z"
        fill="#2C3439"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.50024 11.876C9.68997 11.876 11.4651 10.1009 11.4651 7.91113C11.4651 5.72141 9.68997 3.94629 7.50024 3.94629C5.31052 3.94629 3.5354 5.72141 3.5354 7.91113C3.5354 10.1009 5.31052 11.876 7.50024 11.876ZM10.1532 8.4904C9.88777 9.71146 8.80081 10.626 7.50024 10.626C6.69201 10.626 5.96627 10.2728 5.46894 9.71234C6.01893 9.75796 6.77888 9.74927 7.69532 9.557C8.6766 9.35114 9.47421 8.93613 10.0232 8.57737C10.0681 8.54802 10.1114 8.51899 10.1532 8.4904ZM10.0502 6.97725C9.66946 5.93795 8.67146 5.19629 7.50024 5.19629C6.00088 5.19629 4.7854 6.41177 4.7854 7.91113C4.7854 8.055 4.79659 8.19625 4.81815 8.33406C4.83948 8.33865 4.86078 8.34439 4.88197 8.35133L4.88373 8.35188C4.88724 8.35296 4.89485 8.35524 4.90645 8.35847C4.92966 8.36494 4.9688 8.37518 5.02301 8.38711C5.13147 8.41098 5.3 8.44155 5.52178 8.46217C5.96496 8.5034 6.62161 8.50505 7.43867 8.33364C8.22637 8.16838 8.87965 7.83143 9.33934 7.53101C9.56801 7.38156 9.74517 7.24351 9.86304 7.14487C9.92188 7.09564 9.96563 7.05649 9.99332 7.031C10.0072 7.01826 10.0169 7.00895 10.0226 7.00354L10.0271 6.9992L10.0277 6.99862C10.035 6.99127 10.0426 6.98415 10.0502 6.97725Z"
        fill="#2C3439"
      ></path>
      <circle cx="11.2559" cy="3.08264" r="0.703125" fill="#2C3439"></circle>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaWasher)
